/* eslint-disable import/prefer-default-export */
import NotificationEmailRequests from '../../server/notificationEmail';
import { addLoading, removeLoading } from './loading';

export const setBranchList = branchList => ({
  type: 'SET_BRANCH_LIST',
  branchList,
});

export const getListAndCountAllNotificationEmail = (
  limit, skip, search, orderBy, field, firstRun,
) => async (dispatch) => {
  dispatch(addLoading());
  try {
    const result = await NotificationEmailRequests.getListAndCountAllNotificationEmail(
      limit, skip, search, orderBy, field, firstRun,
    );
    return result;
  } finally {
    dispatch(removeLoading());
  }
};

export const createNotificationEmail = parameters => async (dispatch) => {
  dispatch(addLoading());
  try {
    const result = await NotificationEmailRequests.createNotificationEmail(parameters);
    return result;
  } finally {
    dispatch(removeLoading());
  }
};

export const updateNotificationEmail = parameters => async (dispatch) => {
  dispatch(addLoading());
  try {
    const result = await NotificationEmailRequests.updateNotificationEmail(parameters);
    return result;
  } finally {
    dispatch(removeLoading());
  }
};

export const updateStatusEmail = (id, status) => async (dispatch) => {
  dispatch(addLoading());
  try {
    const result = await NotificationEmailRequests.updateStatusEmail(id, status);
    return result;
  } finally {
    dispatch(removeLoading());
  }
};

export const deleteEmailNotification = id => async (dispatch) => {
  dispatch(addLoading());
  try {
    const result = await NotificationEmailRequests.deleteEmailNotification(id);
    return result;
  } finally {
    dispatch(removeLoading());
  }
};
